// TODO: If you make edits to this file you must deal with these ESLint rules
/*eslint-disable @typescript-eslint/no-explicit-any, jsx-a11y/alt-text */

import React, { useState } from 'react';

import styled from '@emotion/styled';

import FormFieldWarning from '@zego/forms/FormFieldWarning';
import Input from '@zego/forms/Input';
import { unit } from '@zego/theme';

import WarningIcon from '@zego/static/svgs/Warning.svg';

const IconContainer = styled('div')({
  pointerEvents: 'none',
  position: 'absolute',
  top: 0,
  bottom: 0,
  right: 0,
  width: unit(6.5),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const InputContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
  width: '100%',
  position: 'relative',
});

const Container = styled('div')({
  width: '100%',
  position: 'relative',
});

interface WarningInputProps {
  validationFn: (v: string) => boolean;
  warningMessage: string;
  onChange?: (v: string) => void;
  customWidget?: React.ReactElement;
}

const WarningInput = ({
  validationFn,
  warningMessage,
  onChange,
  customWidget: Widget,
  ...props
}: WarningInputProps): JSX.Element => {
  const [warning, setWarning] = useState(false);
  const handleChange = (v: string) => {
    // When the value changes, pass the value back to the onChange event, aswell as
    // setting the `warning` state depending on whether value passes validation.
    onChange && onChange(v);
    const isNotValid = validationFn(v);
    setWarning(isNotValid);
  };
  const inputProps = {
    warning: warning,
    statusIcon: warning && WarningIcon,
    ...props,
  };
  return (
    <Container>
      <InputContainer>
        {React.isValidElement(Widget) ? (
          React.cloneElement(Widget, {
            ...inputProps,
            // Only way to get the value back from the CurrencyInput
            onChange: (v: any) => handleChange(v.floatValue),
          })
        ) : (
          <Input
            onChange={(e: React.BaseSyntheticEvent) =>
              handleChange(e.target.value)
            }
            {...inputProps}
          />
        )}
        {warning && (
          <IconContainer>
            <img src={WarningIcon} />
          </IconContainer>
        )}
      </InputContainer>
      {warningMessage && warning && (
        <FormFieldWarning warning={warningMessage} />
      )}
    </Container>
  );
};

export default WarningInput;
